<button
  mat-icon-button
  [matTooltip]="tooltip()"
  (click)="fileInput.click()"
  [disabled]="disabled()"
>
  @if (!isPending) {
    <ng-content></ng-content>
  } @else {
    @if (progress() === 'bar') {
      <mat-progress-bar mode="indeterminate" class="async-progress-bar"></mat-progress-bar>
    } @else {
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="20"
        strokeWidth="2"
        class="async-spinner"
      >
      </mat-progress-spinner>
    }
  }
</button>

<input
  #fileInput
  hidden
  type="file"
  [multiple]="multiple()"
  [accept]="allowedTypes()"
  [disabled]="disabled()"
  (click)="clearInput($event)"
  (change)="onSelected($event)"
/>
